import React, { FC } from 'react';

type Props = {
    widthPercentage?: number;
    possition?: 'center' | 'left' | 'right';
    mt?: number;
    mb?: number;
}

const FormHr: FC<Props> = ({ widthPercentage = 85, mt = 0, mb = 0, possition = 'center' }) => {

    return (
            <div  style={{
                display: 'flex',
                justifyContent: possition === 'left' ? 'flex-start' : possition === 'right' ? 'flex-end' : 'center',
                marginTop: `${mt}rem`,
                marginBottom: `${mb}rem`
            }}>
                <hr
                    className="bg-secondary border-2 border-top border-secondary"
                    style={{ margin: '0px', width: `${widthPercentage}%` }}
                />
            </div>
        
    );
}

export default FormHr;